import _ from 'lodash'
export {handleName as name} from '../platform.schema'
import {functionLibrary as PlatformHandlers} from './platformHandlers'
import {resolveData} from '../services/resolveData'
import {handleBatchCommand} from './handleBatchCommand'

const CommandTypes = {
    State: 'stateChanged',
    Data: 'dataChanged',
    Design: 'designChanged',
    Props: 'propsChanged',
    EventRegister: 'registerEvent',
    Layout: 'layoutChanged',
    Behavior: 'executeBehavior',
    Style: 'styleChanged',
    ExecuteBatch: 'executeBatch'
}

function handleCommand(runtimeDal, message, callback, resolverGeneralInfo, handleBehavior) {
    switch (message.command) {
        case CommandTypes.Data:
            message.data = resolveData(runtimeDal, message.compId, message.data, resolverGeneralInfo)
            runtimeDal.setCompData(message.compId, message.data)
            break
        case CommandTypes.Props:
            runtimeDal.setCompProps(message.compId, message.data)
            break
        case CommandTypes.Design:
            runtimeDal.setCompDesign(message.compId, message.data)
            break
        case CommandTypes.Behavior:
            handleBehavior(_.assign({}, message.data, {callback}))
            break
        case CommandTypes.Layout:
            throw new Error('Command type is not implemented', message.command)
        case CommandTypes.Style:
            runtimeDal.updateCompStyle(message.compId, message.data)
            break
        case CommandTypes.ExecuteBatch:
            handleBatchCommand(runtimeDal, message.data, resolverGeneralInfo)
            break
        case CommandTypes.EventRegister:
            runtimeDal.registerComponentEvent(message.compId, message.data)
            break
    }
}

function handleSystemMessage(runtimeDal, setIsReady, message, callback, resolverGeneralInfo, handleBehavior) {
    switch (message.type) {
        case 'widget_ready':
            setIsReady(message.widgetId, true)
            break
        case 'console':
            console.log('WORKER CONSOLE', message.data)
            break
        case 'wix_code_iframe_command':
            handleCommand(runtimeDal, message, callback, resolverGeneralInfo, handleBehavior)
            break
        case 'REQUEST_API':
            //TODO: implement this!! it should send "request-api" message
            break
        default: 
            console.log('not implemented', message.type, message)
    }
}

export const defaultModel = {
    isReady: {},
    apiCalls: {}
}

export const functionLibrary = {
    deleteIsReadyEntry: (contextId, setIsReady) => {
        setIsReady(contextId, false)
        return false
    },
    handlePlatformMessage: (runtimeDal, setIsReady, setApiCallMessage, resolverGeneralInfo, handleBehavior, ...args) => {
        if (args.length > 1) {
            console.log('OHOHOHOHOHOHOHOHOHOHOHHOHOHOHOHOHO', 'too many args!!!!!', args)
        }
        const message = args[0].data

        switch (message.intent) {
            case 'WIX_CODE_SITE_API':
                const uniqueMessageId = _.uniqueId('wixCodeApiCall-')
                message.__uniqueId = uniqueMessageId
                setApiCallMessage(message.__uniqueId, message)
                break
            case 'WIX_CODE':
                const callback = _.noop // TODO Reut - create and call callback
                handleSystemMessage(runtimeDal, setIsReady, message, callback, resolverGeneralInfo, handleBehavior)
                break
        }
    },
    ...PlatformHandlers


}
